import React from "react";

function index() {
  return (
    <div className="text" style={{ maxHeight: "70vh", overflow: "auto" }}>
      <p style={{ textAlign: "justify" }}>
        Metode penambahan/assimilasi data masspoint kedalam{" "}
        <em>Digital Surface Model</em>/DSM (IFSAR, TERASAR-X atau ALOS-PALSAR)
        dengan menggunakan <em>GMT-surface </em>dengan <em>tension</em> 0.32.
        Detil proses assimilasi dapat dilihat pada{" "}
        <a href="https://www.star.nesdis.noaa.gov/sod/lsa/GEBCO_Cookbook/documents/CookBook_20161219.pdf">
          IHO-GEBCO Bathymetry Cookbook
        </a>
        ,{" "}
        <a href="https://link.springer.com/article/10.1007/s11001-011-9141-1">
          Hell and Jacobson(2011)
        </a>
        &nbsp;dan lain-lain.
      </p>
      <figure>
        <img
          className="figure-img"
          src={process.env.PUBLIC_URL + "/static/img/DEM_flow.png"}
          style={{ width: "600px" }}
        />
        <figcaption>
          <em>DEM processing flowchart</em>
        </figcaption>
      </figure>
      <p style={{ textAlign: "justify" }}>
        Pengukuran <em>Ground Control Point </em>(GCP) dan Jaring Kontrol
        Geodesi (JKG) digunakan untuk validasi dan uji akurasi data DEMNAS dan
        model data tinggi lainnya. Hasil validasi di Sumatera menunjukkan bahwa
        akurasi DEMNAS lebih baik dibandingkan dengan model data tinggi yang
        dibentuk dari <em>masspoint, spotheight</em> dan <em>breakline</em>{" "}
        (selanjutnya akan disebut DTM). Data DEMNAS, DTM dan DSM (IFSAR,
        TERRASAR-X dan ALOS-PALSAR) untuk wilayah Sumatera (untuk wilayah lain,
        grafik tidak ditampilkan) memiliki <em>Root Mean Square Error</em>{" "}
        (RMSE) masing-masing sebesar 2.79m, 3.24m dan 3.71m dengan{" "}
        <em>bias error</em> -0.13m, -0.63m dan 2.21m untuk data DEMNAS, DTM dan
        DSM.
      </p>
      <figure>
        <img
          className="figure-img"
          src={process.env.PUBLIC_URL + "/static/img/demnas_sum_val.EPS.png"}
          style={{ width: "400px" }}
        />
        <figcaption>
          Selisih GCP/JKG minus EGM2008 dan model data tinggi
        </figcaption>
      </figure>
      <p style={{ textAlign: "justify" }}>
        Selisih nilai pengukuran GNSS dan DEMNAS tidak mempunyai hubungan yang
        berbanding lurus dengan elevasi yang terukur. Perbedaan tinggi ini
        mungkin lebih disebabkan karena tutupan lahan dibanding dengan tinggi
        elevasi. Hubungan selisih DEMNAS dan GNSS dapat dilihat pada grafik
        berikut.
      </p>
      <figure>
        <img
          className="figure-img"
          src={process.env.PUBLIC_URL + "/static//img/error_char.EPS.png"}
          style={{ width: "400px" }}
        />
        <figcaption style={{ padding: "10px" }}>
          Hubungan selisih DEMNAS dan GNSS dengan ketinggian elevasi
        </figcaption>
      </figure>
      <p style={{ textAlign: "justify", padding: "0px" }}>
        Dari sisi akurasi DTM yang dibangun dari <em>masspoint</em> dan{" "}
        <em>breakline</em> mempunyai akurasi yang baik untuk penarikan garis
        kontur dalam peta. Akan tetapi, dalam kasus tertentu yang relatif
        ekstrim, pembuatan DTM dari
        <em>masspoint</em> dan <em>breakline</em>&nbsp;dapat merubah{" "}
        <em>landscape</em> daerah tersebut. Perubahan <em>landscape</em> ini
        disebabkan karena akurasi <em>masspoint</em> dan <em>breakline </em>yang
        rendah baik dari sisi posisi secara horizontal maupun vertikal, sehingga
        menghasilkan DTM yang lebih tinggi dibanding DSM, dan perubahan fitur
        sungai dibeberapa tempat (Gambar dibawah). Sebaliknya proses penambahan
        data <em>masspoint</em> kedalam DSM menggunakan <em>GMT-surface</em>{" "}
        dengan <em>boxcar filter</em> menghasilkan data tinggi dengan kualitas
        lebih baik, dengan membuang masspoint yang tidak akurat.
      </p>
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <figure>
              <img
                className="figure-img"
                src={process.env.PUBLIC_URL + "/static/img/sample_DSM.png"}
                style={{ width: "300px", alignSelf: "center" }}
              />
              <figcaption
                style={{
                  padding: "0px",
                  textAlign: "center",
                  fontSize: "12px",
                  fontFamily: "Lora, serif",
                }}
              >
                <strong>
                  <em>DSM</em>
                </strong>
              </figcaption>
            </figure>
          </div>
          <div className="col-md-4" style={{ width: "300px" }}>
            <figure>
              <img
                className="figure-img"
                src={process.env.PUBLIC_URL + "/static/img/sample_prt.png"}
                style={{ width: "300px", alignSelf: "center" }}
              />
              <figcaption
                style={{
                  padding: "0px",
                  textAlign: "center",
                  fontSize: "12px",
                  fontFamily: "Lora, serif",
                }}
              >
                <strong>
                  <em>DTM(masspoint+breakline)</em>
                </strong>
              </figcaption>
            </figure>
          </div>
          <div className="col-md-4">
            <figure>
              <img
                className="figure-img"
                src={process.env.PUBLIC_URL + "/static/img/sample_DEMNAS.png"}
                style={{ width: "300px", alignSelf: "center" }}
              />
              <figcaption
                style={{
                  padding: "0px",
                  textAlign: "center",
                  fontSize: "12px",
                  fontFamily: "Lora, serif",
                }}
              >
                <strong>
                  <em>DEMNAS</em>
                </strong>
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-10 col-xl-8 offset-lg-1 offset-xl-2">
            <div className="text">
              <p style={{ textAlign: "justify" }}>
                Efek dari konversi datum tinggi dari EGM96 menjadi EGM2008
                terlihat pada DSM yang masih menggunakan EGM96 dan DEMNAS yang
                merujuk pada EGM2008. Selanjutnya, anomali tinggi juga terlihat
                pada data DTM yang didapatkan dari <em>masspoint </em>dan
                <em> breakline</em> hasil interpretasi <em>stereo-plotting </em>
                di daerah bagian selatan, dengan data DTM yang lebih tinggi
                dibanding DSM, 10m atau lebih. Anomali bentuk lahan lainnya,
                juga terlihat pada pola aliran dan muara sungai di bagian
                utara.&nbsp;
              </p>
            </div>
            {/*
            <h2 className="text-justify" style={{ fontSize: "20px" }}>
              <strong>Batimetri Nasional</strong>
            </h2>
            <div className="text">
              <p style={{ textAlign: "justify" }}>
                Pengembangan data model <em>gridded</em> Batimetri Nasional
                dimulai dari perhitungan data <em>free air gravity anomaly</em>,
                sampai menjadi data batimetri dengan menggunakan
                Gravity-Geological Method (GGM). Detil penggunaan model GGM
                dapat ditemukan pada
                <a href="http://agl.nchu.edu.tw/AlldataPos/ArticlePos/(2016)High-resolution%20depth%20and%20coastline%20over%20major%20atolls%20of%20South%20China%20Sea.pdf">
                  {" "}
                  Hsiao <em>et. al&nbsp;</em>(2016)
                </a>
                &nbsp;dan lain-lain, dan metode assimilasi data pemeruman
                kedalam data batimetri, misalnya dalam{" "}
                <a href="http://topex.ucsd.edu/sandwell/publications/124_MG_Becker.pdf">
                  Becker <em>et. al&nbsp;</em>(2009)
                </a>
                .
              </p>
              <figure>
                <img
                  className="figure-img"
                  src={process.env.PUBLIC_URL + "/static/img/flow_batnas.png"}
                  style={{ width: "400px" }}
                />
                <figcaption style={{ padding: "10px" }}>
                  <em>Flow chart </em>pemrosesan data batimetri (dimodifikasi
                  dari{" "}
                  <a href="http://agl.nchu.edu.tw/AlldataPos/ArticlePos/(2016)High-resolution%20depth%20and%20coastline%20over%20major%20atolls%20of%20South%20China%20Sea.pdf">
                    Hsiao <em>et al.&nbsp;</em>(2016)
                  </a>
                  )
                </figcaption>
              </figure>
              <p style={{ textAlign: "justify" }}>
                Penilaian akurasi data <em>free air gravity anomaly</em>
                &nbsp;dilakukan dengan membandingkan hasil model terhadap data{" "}
                <em>shipborne. </em>Tabel hasil perbandingan data shipborne
                dengan data <em>gravity model</em> BIG, DTU10 dan Sandwell v24.1
                seperti berikut:&nbsp;
              </p>
            </div>
            <div className="table-responsive">
              <table className="table table-striped table-hover table-sm">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Mean diff (mgal)</th>
                    <th>std. dev (mgal)</th>
                    <th>min (mgal)</th>
                    <th>max (mgal)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>BIG1m-G</td>
                    <td>
                      -0.51
                      <br />
                    </td>
                    <td>9.31</td>
                    <td>-103.16</td>
                    <td>101.87</td>
                  </tr>
                  <tr>
                    <td>Sandwel 24.1</td>
                    <td>-0.72</td>
                    <td>9.47</td>
                    <td>-121.92</td>
                    <td>108.71</td>
                  </tr>
                  <tr>
                    <td>DTU10</td>
                    <td>-1.07</td>
                    <td>9.84</td>
                    <td>-103.65</td>
                    <td>102.45</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p style={{ textAlign: "justify", fontSize: "16px" }}>
              Hasil uji akurasi menunjukkan bahwa <em>marine gravity model</em>{" "}
              yang dikembangkan mempunyai akuarasi yang memadai, sebagai dasar
              untuk estimasi model batimetri pada resolusi 1m (<em>1 minute</em>
              ) sebelum dilakukan iterasi asimilasi data pemeruman, dari
              resolusi 1m sampai 6-<em>arcsecond.</em>
            </p>
            <p style={{ textAlign: "justify", fontSize: "16px" }}>
              Hasil survei hidrografi pada kegiatan{" "}
              <em>Digital Marine Resource Mapping</em> (DMRM) digunakan sebagai
              validator data model <em>gridded </em>Batimetri Nasional, dari
              resolusi 1m, <em>30-seconds, 15-seconds</em>. Sebagai pembanding,
              uji akurasi ini juga dilakukan terhadap data batimetri global yang
              ada, misalnya GEBCO30s edisi tahun 2014, SRTM30 dan SRTM15 plus.
              Validasi di daerah pantai yang sebagian besar sudah ditambahkan
              data hasil survei Pusat Kelautan dan Lingkungan Pantai (PKLP),
              BIG, tidak lagi diperlukan. Asimilasi data pemeruman di perairan
              dangkal dan daerah pantai menjadikan data&nbsp;<em>gridded</em>{" "}
              Batimetri yang dikembangkan oleh Tim DEMNAS BIG, akan mempunyai
              akurasi terbaik di daerah pantai Kepulauan Indonesia, dibanding
              data model batimetri lainnya.
            </p>
            <p style={{ textAlign: "justify", fontSize: "16px" }}>
              Batimetri Nasional dengan resolusi 30s, memiliki bias error
              -12.22m sedangkan data SRTM30plus dan GEBCO30s masing-masing
              -18.51m dan -24.7m. Selanjutnya, standar deviasi untuk BATNAS,
              SRTM30plus, dan GEBCO30s masing-masing adalah 47.32m, 151.4m dan
              171.53m. Sementara itu, pada resolusi 15s, data BATNAS mempunyai{" "}
              <em>bias error</em>&nbsp; -9.21m dan standar deviasi 39.75.
              Sementara SRTM15plus mempunyai <em>bias error </em>-15.71m dan
              standar deviasi 146.53m. Contoh perbedaan detil batimetri antara
              SRTM15plus dan BATNAS-15s seperti Gambar berikut.
            </p>
            <figure style={{ textAlign: "center" }}>
              <img
                className="figure-img"
                src={process.env.PUBLIC_URL + "/static/img/sample_srtm15.png"}
                style={{ width: "500px" }}
              />
              <figcaption style={{ padding: "10px" }}>
                <em>Gridded </em>batimetri SRTM15plus
              </figcaption>
            </figure>
            <figure style={{ textAlign: "center" }}>
              <img
                className="figure-img"
                src={process.env.PUBLIC_URL + "/static/img/sample_BIG15s.png"}
                style={{ width: "500px" }}
              />
              <figcaption style={{ padding: "10px" }}>
                <em>Gridded </em>batimetri BIG-15s, sebelum dilakukan{" "}
                <em>masking</em> daratan
              </figcaption>
            </figure>
            <p style={{ textAlign: "justify", fontSize: "16px" }}>
              Datum yang digunakan dalam BATNAS adalah EGM2008 dan MSL. Hubungan
              antara Geoid dan MSL didefiniskan dengan jelas dalam "
              <a href="https://www.researchgate.net/publication/278690726_Geodetic_World_Height_System_Unification">
                <em>Geodetic World Height System Unification</em>
              </a>
              ". Selanjutnya, contoh implementasi penggunaan ocean model,
              stasiun pasut dan survei GNSS dapat dilihat di{" "}
              <a href="http://nora.nerc.ac.uk/id/eprint/21329/7/woodworth_etal_jgs_2012.pdf">
                woodworth <em>et al.</em>(2012)
              </a>
              . Dalam menghitung MSL di Perairan Indonesia,{" "}
              <a href="https://www.researchgate.net/publication/279326227_Estimating_the_Steric_Sea_Level_Rise_in_Indonesian_Seas_Using_An_Oceanic_General_Circulation_Model">
                BIG menggunakan HYCOM
              </a>
              &nbsp;dengan resolusi lebih baik dibanding model yang digunakan
              dalam&nbsp;&nbsp;
              <a href="http://nora.nerc.ac.uk/id/eprint/21329/7/woodworth_etal_jgs_2012.pdf">
                woodworth&nbsp;<em>et al.</em>(2012)
              </a>
              . Beberapa hasil simulasi model laut dengan berbagai resolusi dari
              skala global sampai regional dapat dilihat di{" "}
              <a href="http://tides.big.go.id/las">
                http://tides.big.go.id/las
              </a>
              . Secara sederhana, hubungan antara hasil model laut dan geoid
              dapat dilihat pada Gambar berikut:
              <br />
            </p>
            <figure style={{ textAlign: "center" }}>
              <img
                className="figure-img"
                src={
                  process.env.PUBLIC_URL + "/static/img/unifikasi_datum3.png"
                }
                style={{ width: "350px" }}
              />
              <figcaption style={{ padding: "10px" }}>
                Hubungan MSL dan geoid
              </figcaption>
            </figure>
            */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default index;
